// From https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob, needed for Safari:
import {date_newDate_fd, date_pastXHours_fb, date_pastXSecond_fb} from "./S_Date";
import {enum_langCodes} from "../../functions/src/shareCode/Share_S_Enum";
import {
    ass_img_flagFrench_c,
    ass_img_flagIsrael_c,
    ass_img_flagSpain_c,
    ass_img_flagUsa_c
} from "../assets/scripts/Ass_Files";

if (!HTMLCanvasElement.prototype.toBlob) {
    Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
        value: function(callback, type, quality) {

            let binStr = atob(this.toDataURL(type, quality).split(',')[1]),
                len = binStr.length,
                arr = new Uint8Array(len);

            for (let i = 0; i < len; i++) {
                arr[i] = binStr.charCodeAt(i);
            }

            callback(new Blob([arr], {type: type || 'image/png'}));
        }
    });
}

window.URL = window.URL || window.webkitURL;

// Modified from https://stackoverflow.com/a/32490603, cc by-sa 3.0
// -2 = not jpeg, -1 = no data, 1..8 = orientations
const getExifOrientation = (file, callback) => {
    // Suggestion from http://code.flickr.net/2012/06/01/parsing-exif-client-side-using-javascript-2/:
    if (file.slice) {
        file = file.slice(0, 131072);
    } else if (file.webkitSlice) {
        file = file.webkitSlice(0, 131072);
    }

    let reader = new FileReader();
    reader.onload = function(e) {
        let view = new DataView(e.target.result);
        if (view.getUint16(0, false) != 0xFFD8) {
            callback(-2);
            return;
        }
        let length = view.byteLength, offset = 2;
        while (offset < length) {
            let marker = view.getUint16(offset, false);
            offset += 2;
            if (marker == 0xFFE1) {
                if (view.getUint32(offset += 2, false) != 0x45786966) {
                    callback(-1);
                    return;
                }
                let little = view.getUint16(offset += 6, false) == 0x4949;
                offset += view.getUint32(offset + 4, little);
                let tags = view.getUint16(offset, little);
                offset += 2;
                for (let i = 0; i < tags; i++)
                    if (view.getUint16(offset + (i * 12), little) == 0x0112) {
                        callback(view.getUint16(offset + (i * 12) + 8, little));
                        return;
                    }
            }
            else if ((marker & 0xFF00) != 0xFF00) break;
            else offset += view.getUint16(offset, false);
        }
        callback(-1);
    };
    reader.readAsArrayBuffer(file);
}

// Derived from https://stackoverflow.com/a/40867559, cc by-sa
const imgToCanvasWithOrientation =(img, rawWidth, rawHeight, orientation) => {
    let canvas = document.createElement('canvas');
    if (orientation > 4) {
        canvas.width = rawHeight;
        canvas.height = rawWidth;
    } else {
        canvas.width = rawWidth;
        canvas.height = rawHeight;
    }

    if (orientation > 1) {
        console.log("EXIF orientation = " + orientation + ", rotating picture");
    }

    let ctx = canvas.getContext('2d');
    switch (orientation) {
        case 2: ctx.transform(-1, 0, 0, 1, rawWidth, 0); break;
        case 3: ctx.transform(-1, 0, 0, -1, rawWidth, rawHeight); break;
        case 4: ctx.transform(1, 0, 0, -1, 0, rawHeight); break;
        case 5: ctx.transform(0, 1, 1, 0, 0, 0); break;
        case 6: ctx.transform(0, 1, -1, 0, rawHeight, 0); break;
        case 7: ctx.transform(0, -1, -1, 0, rawHeight, rawWidth); break;
        case 8: ctx.transform(0, -1, 1, 0, 0, rawWidth); break;
    }
    ctx.drawImage(img, 0, 0, rawWidth, rawHeight);
    return canvas;
}

// file_getFileBlobFromBlobUrl
export const file_getFileBlobFromBlobUrl_f = (blobUrl, cb=() => {}, cbError_f = () => {}) => {

    const xhr = new XMLHttpRequest();
    xhr.open("GET", blobUrl);
    xhr.responseType = "blob";
    xhr.addEventListener('load', () => {
        cb(xhr.response);
    });

    xhr.onerror = (e) => {
        cbError_f()
        console.log("error", xhr.responseText)
    }

    xhr.send();
};

// file_getFileBlobFromFbUrl_f
export const file_getFileBlobFromFbUrl_fp = (url_s, cb_f) => {
    return fetch(url_s)
        .then(res => res.blob()) // Gets the response and returns it as a blob
        .then(blob => {
            if(cb_f) cb_f(blob)
            return blob
        });
}

// file_reduceImageFileSize
export const file_reduceImageFileSize = (fileUrl, acceptFileSize, maxWidth, maxHeight, quality, callback) => {

    file_getFileBlobFromBlobUrl_f(fileUrl, (file) => {

        if (file.size <= acceptFileSize) {
            callback(file);
            return;
        }
        let img = new Image();
        img.onerror = function() {
            URL.revokeObjectURL(this.src);
            callback(file);
        };
        img.onload = function() {
            URL.revokeObjectURL(this.src);
            getExifOrientation(file, function(orientation) {
                let w = img.width, h = img.height;
                let scale = (orientation > 4 ?
                    Math.min(maxHeight / w, maxWidth / h, 1) :
                    Math.min(maxWidth / w, maxHeight / h, 1));
                h = Math.round(h * scale);
                w = Math.round(w * scale);

                let canvas = imgToCanvasWithOrientation(img, w, h, orientation);
                canvas.toBlob(function(blob) {
                    console.log("Resized image to " + w + "x" + h + ", " + (blob.size >> 10) + "kB - " + Math.floor(blob.size/file.size * 100) + "%" ) ;
                    callback(blob);
                }, 'image/jpeg', quality);
            });
        };
        img.src = URL.createObjectURL(file);

    })

}

// file_downloadJson_f
export const file_downloadJson_f = (exportName, exportObj) => {

    let dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(exportObj));
    let downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute("href",     dataStr);
    downloadAnchorNode.setAttribute("download", exportName + ".json");
    document.body.appendChild(downloadAnchorNode); // required for firefox
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
}

// file_loadJsonFile_f
export const file_loadJsonFile_f = (cb_f) => {

    let tag = document.createElement('input');
    tag.setAttribute("type",    'file');
    tag.setAttribute("accept",  '.json,application/json');
    tag.onchange = (event) => {

        let blob = event.target.files[0]
        const reader = new FileReader();

        reader.addEventListener('loadend', (e) => {
            const text = e.srcElement.result;
            cb_f(JSON.parse(text))
        });

        reader.readAsText(blob);

    }
    document.body.appendChild(tag); // required for firefox
    tag.click();
    tag.remove();
}

// file_initAudio_f
let soundEffect = null
export const file_initAudio_f = (audioFile_r) => {

    if(soundEffect == null){

        soundEffect = new Audio();
        soundEffect.autoplay = true;

        // onClick of first interaction on page before I need the sounds
        // (This is a tiny MP3 file that is silent and extremely short - retrieved from https://bigsoundbank.com and then modified)
        soundEffect.src = audioFile_r;
    }

}

// file_playAudio
let lastPlayAudio_byR_t = {}
export const file_playAudio_f = (audioFile_r) => {

    if( soundEffect != null && audioFile_r &&
        (lastPlayAudio_byR_t[audioFile_r] == null || date_pastXSecond_fb(lastPlayAudio_byR_t[audioFile_r], 0.3))){

        lastPlayAudio_byR_t[audioFile_r] = (date_newDate_fd()).getTime()

        // later on when you actually want to play a sound at any point without user interaction
        soundEffect.src = audioFile_r;
        soundEffect.play()

        // let audio = new Audio(audioFile_r)
        // audio.play()
        //     .catch(err =>{
        //         console.log("file_playAudio", err)
        //     })


    }
}

// file_getLangFlagByLangCode_fr
export const file_getLangFlagByLangCode_fr = (langCode) => {
    switch (langCode) {
        case enum_langCodes.english:
            return ass_img_flagUsa_c
        case enum_langCodes.hebrew:
            return ass_img_flagIsrael_c
        case enum_langCodes.french:
            return ass_img_flagFrench_c
        case enum_langCodes.spanish:
            return ass_img_flagSpain_c
    }
}




